document.addEventListener( 'DOMContentLoaded', () => {
	if ( window.location.href.includes( 'profil' ) ) {
		return;
	}

	const targets = document.querySelectorAll( '.accordion' );

	targets.forEach( ( el ) => {
		el.onclick = ( event ) => window.location.hash = event.target.dataset.bsTarget;
	} );
} );
